import { connect } from 'react-redux';
import { onChangeVendorView } from '../../../actions/vendors/otherVendors';
import { OtherVendorsMain } from './OtherVendorsMain';

const mapStateToProps = (state: any) => {
  const { vendor, user } = state;
  return {
    vendors: vendor, // Map vendor state to vendors prop for consistency with component
    user
  };
};

export const OtherVendors = connect(mapStateToProps, {
  onChangeVendorView,
})(OtherVendorsMain);
